export default __webpack_public_path__ + "static/media/InsideLungs_05.946a2465.png";